import * as amplitude from '@amplitude/analytics-browser';
import { createContext, useContext } from 'react';
import {
  AmplitudeConfig,
  AmplitudeContextData as ContextData,
  AmplitudeContextProps as ContextProps,
} from './types';

// const TRACKING_ACTIVE = process.env.NODE_ENV === 'production';
const TRACKING_ACTIVE = false;

const context = createContext<ContextData>({} as ContextData);

const { Provider } = context;

export const useAmplitudeContext = () => useContext(context);

export const AmplitudeProvider = ({
  children,
  token,
  config,
}: ContextProps) => {
  const instance = AmplitudeService.getInstance(token, config);

  return <Provider value={{ amplitude: instance }}>{children}</Provider>;
};

export class AmplitudeService {
  private static instance: AmplitudeService;

  private constructor(token?: string, config?: Partial<AmplitudeConfig>) {
    if (token && TRACKING_ACTIVE)
      amplitude.init(token, {
        autocapture: true,
        ...config,
      });
  }

  static getInstance(
    token?: string,
    config?: Partial<AmplitudeConfig>
  ): AmplitudeService {
    if (!AmplitudeService.instance && TRACKING_ACTIVE) {
      AmplitudeService.instance = new AmplitudeService(token, config);
    }
    return AmplitudeService.instance;
  }

  identifyUser(userId?: string, userProperties?: Record<string, any>) {
    amplitude.setUserId(userId);

    if (userProperties) {
      const identifyObj = new amplitude.Identify();
      Object.entries(userProperties).forEach(([key, value]) => {
        identifyObj.set(key, value);
      });
      amplitude.identify(identifyObj);
    }
  }

  resetUser() {
    amplitude.reset();
  }

  getUserId() {
    return amplitude.getUserId();
  }

  trackEvent(
    eventName: string,
    eventData?: Record<string, any>,
    eventOptions?: amplitude.Types.EventOptions
  ) {
    amplitude.track(eventName, eventData, eventOptions);
  }
}
